function characterLevels(tommyTotalArray, otherTotalArray) {
  const tommyAddedUp = tommyTotalArray.reduce((a, c) => (a += c), 0);
  const otherAddedUp = otherTotalArray.reduce((a, c) => (a += c), 0);

  const otherPercentages = {
    vigor: 0,
    mind: 0,
    endurance: 0,
    strength: 0,
    dexterity: 0,
    intelligence: 0,
    faith: 0,
    arcane: 0,
  };

  const myFinalLevel = {
    vigor: 0,
    mind: 0,
    endurance: 0,
    strength: 0,
    dexterity: 0,
    intelligence: 0,
    faith: 0,
    arcane: 0,
  };

  const mappedOther = Object.keys(otherPercentages).map(
    (key, i) => (otherPercentages[key] += (otherTotalArray[i] / otherAddedUp) * 100)
  );

  const mappedTommy = Object.keys(myFinalLevel).map(
    (key, i) => (myFinalLevel[key] += (tommyTotalArray[i] / tommyAddedUp) * 100)
  );

  let result = [];

  for (let i = 0; i < Object.keys(myFinalLevel).length; i++) {
    result.push(
      `change your ${Object.keys(myFinalLevel)[i]}, current level ${
        tommyTotalArray[i]
      }, to ${(Object.values(otherPercentages)[i] * tommyAddedUp) / 100} \n`
    );
  }

  //console.log('other guys percentages: ', otherPercentages);
  //console.log('my percentages: ', myFinalLevel);

  return result;
}

//console.log(characterLevels([1, 2, 2, 3, 4, 5, 6, 7], [10, 20, 20, 30, 40, 50, 60, 70]));

export default characterLevels;
